import type { FC } from "react"

const Search: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      className={className}
      width="22px"
      height="22px"
      viewBox="0 0 22 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="header-/-all"
          transform="translate(-1492.000000, -39.000000)"
          fill="currentColor"
        >
          <path
            d="M1494.12195,50.0243902 C1494,49.5365854 1494,49.0487805 1494,48.5609756 C1494,44.4146341 1497.41463,41 1501.56098,41 C1502.04878,41 1502.53659,41 1503.02439,41.1219512 C1503.26829,41.1219512 1503.5122,41.2439024 1503.7561,41.3658537 C1504,41.4878049 1504.2439,41.4878049 1504.4878,41.6097561 C1504.97561,41.7317073 1505.34146,41.9756098 1505.70732,42.2195122 C1506.56098,42.8292683 1507.29268,43.4390244 1507.78049,44.2926829 C1508.02439,44.6585366 1508.26829,45.1463415 1508.39024,45.5121951 C1508.5122,45.7560976 1508.5122,46 1508.63415,46.2439024 C1508.7561,46.4878049 1508.7561,46.7317073 1508.87805,46.9756098 C1509,47.4634146 1509,47.9512195 1509,48.4390244 C1509,52.5853659 1505.58537,56 1501.43902,56 C1500.95122,56 1500.46341,56 1499.97561,55.8780488 C1499.73171,55.8780488 1499.4878,55.7560976 1499.2439,55.6341463 C1498.5122,55.3902439 1497.90244,55.1463415 1497.29268,54.6585366 C1497.04878,54.5365854 1496.92683,54.4146341 1496.68293,54.1707317 C1496.43902,54.0487805 1496.31707,53.804878 1496.19512,53.6829268 C1495.82927,53.5609756 1495.58537,53.195122 1495.21951,52.7073171 C1495.09756,52.4634146 1494.97561,52.3414634 1494.85366,52.097561 C1494.73171,51.9756098 1494.73171,51.7317073 1494.60976,51.6097561 C1494.4878,51.3658537 1494.4878,51.1219512 1494.36585,50.7560976 C1494.2439,50.5121951 1494.2439,50.2682927 1494.12195,50.0243902 Z M1512.22284,61 C1511.73259,61 1511.24234,60.877095 1510.87465,60.5083799 L1506.58496,56.2067039 C1505.11421,57.1899441 1503.27577,57.6815642 1501.43733,57.6815642 C1498.98607,57.6815642 1496.53482,56.698324 1494.81894,54.9776536 C1492.9805,53.2569832 1492,50.7988827 1492,48.3407821 C1492,43.1787709 1496.16713,39 1501.31476,39 C1503.76602,39 1506.21727,39.9832402 1507.93315,41.7039106 C1509.64903,43.424581 1510.62953,45.8826816 1510.62953,48.3407821 C1510.62953,50.1843575 1510.13928,51.9050279 1509.15877,53.5027933 L1513.44847,57.8044693 C1514.18384,58.5418994 1514.18384,59.7709497 1513.44847,60.5083799 C1513.20334,60.877095 1512.71309,61 1512.22284,61 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export default Search
